import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class DispoService {
	constructor(private dataService: OldDataService, private http: HttpClient, private utils: UtilsService) {}

	// campaigns_dispo(dateStart: string, dateEnd: string) {
	// 	const url = `${borrarEnvironment.api}dispos/campaigns_dispo.php`;
	// 	return this.dataService.post(url, {
	// 		dateStart: dateStart,
	// 		dateEnd: dateEnd,
	// 	});
	// }
	// users_dispo(dateStart: string, dateEnd: string, campaignId: number) {
	// 	const url = `${borrarEnvironment.api}dispos/users_dispo.php`;
	// 	return this.dataService.post(url, {
	// 		dateStart: dateStart,
	// 		dateEnd: dateEnd,
	// 		campaign_id: campaignId,
	// 	});
	// }

	// dispo_history_by_user(
	// 	dateStart: string,
	// 	dateEnd: string,
	// 	campaignId: number,
	// 	userID: number,
	// ) {
	// 	const url = `${borrarEnvironment.api}dispos/dispos_by_user.php`;
	// 	return this.dataService.post(url, {
	// 		dateStart: dateStart,
	// 		dateEnd: dateEnd,
	// 		campaign_id: campaignId,
	// 		userid: userID,
	// 	});
	// }
	// campaigns_dispo_by_user(
	// 	dateStart: string,
	// 	dateEnd: string,
	// 	userID: number,
	// ) {
	// 	const url = `${borrarEnvironment.api}dispos/campaigns_dispo_by_user.php`;
	// 	return this.dataService.post(url, {
	// 		dateStart: dateStart,
	// 		dateEnd: dateEnd,
	// 		userid: userID,
	// 	});
	// }

	get_fyi_dispos() {
		const url = `${environment.api}dispos/get_fyi_dispos.php`;
		return this.http.get(url);
	}

	getDisposReport(from_date: string, to_date: string, dispoType: string ){
		const url = `${environment.api}dispos/get_dispos_report`;
		const formData: any = this.utils.jsonToFormData({ from_date: from_date, to_date: to_date, dispo_type: dispoType });
		return this.http.post(url, formData);
	}

	getDispoDetails(dispo_id){
		const url = `${environment.api}dispos/${dispo_id}/dispo_details`;
		return this.http.get(url);
	}
}
